module.exports = __webpack_public_path__ + "static/media/login-background.212dc91c.png";